import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getOurBrandDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  ourBrandPageContent: [
    {
      fieldName: "Title (EN)",
      fieldValue: "data.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    
    {
      fieldName: "Title (MS)",
      fieldValue: "data.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_title",
      formType: "input",
      label: "Title (MS)",
      placeholder: "Enter Title (MS)",
      // validation: { required: "Title (MS) is required" },
    },
    
    {
      fieldName: "Title (ZH)",
      fieldValue: "data.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_title",
      formType: "input",
      label: "Title (ZH)",
      placeholder: "Enter Title (ZH)",
      // validation: { required: "Title (ZH) is required" },
    },
    
    {
      fieldName: "Image",
      fieldValue: "data.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Enter Image",
      validation: { required: "Image is required" },
    },
    
    // {
    //   fieldName: "Image (MS)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_malay_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (MS)",
    //   placeholder: "Enter Image (MS)",
    //   hidden: true
    //   // validation: { required: "Image (MS) is required" },
    // },
    
    // {
    //   fieldName: "Image (ZH)",
    //   fieldValue: "data.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_mandarin_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Image (ZH)",
    //   placeholder: "Enter Image (ZH)",
    //   hidden: true
    //   // validation: { required: "Image (ZH) is required" },
    // },
    
    {
      fieldName: "Description (EN)",
      fieldValue: "data.description",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    
    {
      fieldName: "Description (MS)",
      fieldValue: "data.description",
      parseField: "field_content_malay",
      className: "col-span-12",
      type: "content",
      name: "field_content_malay_description",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    
    {
      fieldName: "Description (ZH)",
      fieldValue: "data.description",
      parseField: "field_content_mandarin",
      className: "col-span-12",
      type: "content",
      name: "field_content_mandarin_description",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    
    {
      fieldName: "Vision Title (EN)",
      fieldValue: "data.vision.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_vision_title",
      formType: "input",
      label: "Vision Title (EN)",
      placeholder: "Enter Vision Title (EN)",
      validation: { required: "Vision Title (EN) is required" },
    },
    
    {
      fieldName: "Vision Title (MS)",
      fieldValue: "data.vision.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_vision_title",
      formType: "input",
      label: "Vision Title (MS)",
      placeholder: "Enter Vision Title (MS)",
      // validation: { required: "Vision Title (MS) is required" },
    },
    
    {
      fieldName: "Vision Title (ZH)",
      fieldValue: "data.vision.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_vision_title",
      formType: "input",
      label: "Vision Title (ZH)",
      placeholder: "Enter Vision Title (ZH)",
      // validation: { required: "Vision Title (ZH) is required" },
    },
    
    {
      fieldName: "Vision Image",
      fieldValue: "data.vision.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_vision_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Vision Image",
      placeholder: "Enter Vision Image",
      validation: { required: "Vision Image is required" },
    },
    
    // {
    //   fieldName: "Vision Image (MS)",
    //   fieldValue: "data.vision.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_malay_vision_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Vision Image (MS)",
    //   placeholder: "Enter Vision Image (MS)",
    //   hidden: true
    //   // validation: { required: "Vision Image (MS) is required" },
    // },
    
    // {
    //   fieldName: "Vision Image (ZH)",
    //   fieldValue: "data.vision.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_mandarin_vision_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Vision Image (ZH)",
    //   placeholder: "Enter Vision Image (ZH)",
    //   hidden: true
    //   // validation: { required: "Vision Image (ZH) is required" },
    // },
    {
      fieldName: "Vision Description (EN)",
      fieldValue: "data.vision.description",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_vision_description",
      formType: "richText",
      label: "Vision Description (EN)",
      placeholder: "Enter Vision Description (EN)",
      validation: { required: "Vision Description (EN) is required" },
    },
    
    {
      fieldName: " Vision Description (MS)",
      fieldValue: "data.vision.description",
      parseField: "field_content_malay",
      className: "col-span-12",
      type: "content",
      name: "field_content_malay_vision_description",
      formType: "richText",
      label: " Vision Description (MS)",
      placeholder: "Enter  Vision Description (MS)",
      // validation: { required: " Vision Description (MS) is required" },
    },
    
    {
      fieldName: " Vision Description (ZH)",
      fieldValue: "data.vision.description",
      parseField: "field_content_mandarin",
      className: "col-span-12",
      type: "content",
      name: "field_content_mandarin_vision_description",
      formType: "richText",
      label: " Vision Description (ZH)",
      placeholder: "Enter  Vision Description (ZH)",
      // validation: { required: " Vision Description (ZH) is required" },
    },
    {
      fieldName: "Brand Promise Title (EN)",
      fieldValue: "data.brandPromise.title",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_brandPromise_title",
      formType: "input",
      label: "Brand Promise Title (EN)",
      placeholder: "Enter Brand Promise Title (EN)",
      validation: { required: "Brand Promise Title (EN) is required" },
    },
    
    {
      fieldName: "Brand Promise Title (MS)",
      fieldValue: "data.brandPromise.title",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_brandPromise_title",
      formType: "input",
      label: "Brand Promise Title (MS)",
      placeholder: "Enter Brand Promise Title (MS)",
      // validation: { required: "Brand Promise Title (MS) is required" },
    },
    
    {
      fieldName: "Brand Promise Title (ZH)",
      fieldValue: "data.brandPromise.title",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_brandPromise_title",
      formType: "input",
      label: "Brand Promise Title (ZH)",
      placeholder: "Enter Brand Promise Title (ZH)",
      // validation: { required: "Brand Promise Title (ZH) is required" },
    },
    
    {
      fieldName: "Brand Promise Image",
      fieldValue: "data.brandPromise.image",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "image",
      name: "field_content_english_brandPromise_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Brand Promise Image",
      placeholder: "Enter Brand Promise Image",
      validation: { required: "Brand Promise Image is required" },
    },
    
    // {
    //   fieldName: "Brand Promise Image (MS)",
    //   fieldValue: "data.brandPromise.image",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_malay_brandPromise_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Brand Promise Image (MS)",
    //   placeholder: "Enter Brand Promise Image (MS)",
    //   hidden: true
    //   // validation: { required: "Brand Promise Image (MS) is required" },
    // },
    
    // {
    //   fieldName: "Brand Promise Image (ZH)",
    //   fieldValue: "data.brandPromise.image",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_content_mandarin_brandPromise_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Brand Promise Image (ZH)",
    //   placeholder: "Enter Brand Promise Image (ZH)",
    //   hidden: true
    //   // validation: { required: "Brand Promise Image (ZH) is required" },
    // },
    {
      fieldName: "Brand Promise Description (EN)",
      fieldValue: "data.brandPromise.description",
      parseField: "field_content_english",
      className: "col-span-12",
      type: "content",
      name: "field_content_english_brandPromise_description",
      formType: "richText",
      label: "Brand Promise Description (EN)",
      placeholder: "Enter Brand Promise Description (EN)",
      validation: { required: "Brand Promise Description (EN) is required" },
    },
    
    {
      fieldName: "Brand Promise Description (MS)",
      fieldValue: "data.brandPromise.description",
      parseField: "field_content_malay",
      className: "col-span-12",
      type: "content",
      name: "field_content_malay_brandPromise_description",
      formType: "richText",
      label: "Brand Promise Description (MS)",
      placeholder: "Enter Brand Promise Description (MS)",
      // validation: { required: "Brand Promise Description (MS) is required" },
    },
    
    {
      fieldName: "Brand Promise Description (ZH)",
      fieldValue: "data.brandPromise.description",
      parseField: "field_content_mandarin",
      className: "col-span-12",
      type: "content",
      name: "field_content_mandarin_brandPromise_description",
      formType: "richText",
      label: "Brand Promise Description (ZH)",
      placeholder: "Enter Brand Promise Description (ZH)",
      // validation: { required: "Brand Promise Description (ZH) is required" },
    },
    // {
    //   fieldName: "Next Page Name (EN)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_english",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_english_nextPage_name",
    //   formType: "input",
    //   label: "Next Page Name (EN)",
    //   placeholder: "Enter Next Page Name (EN)",
    //   validation: { required: "Next Page Name (EN) is required" },
    // },
    // {
    //   fieldName: "Next Page Name (MS)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay_nextPage_name",
    //   formType: "input",
    //   label: "Next Page Name (MS)",
    //   placeholder: "Enter Next Page Name (MS)",
    //   // validation: { required: "Next Page Name (MS) is required" },
    // },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay_nextPage_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   // validation: { required: "Next Page Link (MS) is required" },
    // },
    // {
    //   fieldName: "Next Page Name (ZH)",
    //   fieldValue: "data.nextPage.name",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin_nextPage_name",
    //   formType: "input",
    //   label: "Next Page Name (ZH)",
    //   placeholder: "Enter Next Page Name (ZH)",
    //   // validation: { required: "Next Page Name (ZH) is required" },
    // },
//     {
//       fieldName: "Next Page Link",
//       fieldValue: "data.nextPage.link",
//       parseField: "field_content_english",
//       className: "col-span-6",
//       type: "content",
//       name: "field_content_english_nextPage_link",
//       formType: "input",
//       label: "Next Page Link",
//       placeholder: "Enter Next Page Link",
//       validation: { required: "Next Page Link is required",validate: (value: string) => {
//   const trimmed = value.trim();
//   if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
//   if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
//     return "Looks like an external link. Please use an in-app page link, such as /example";
//   }
//   return true;
// } },
//     },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin_nextPage_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: { required: "Next Page Link (ZH) is required" },
    // },
  ],
  ourBrandPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  ourPoliciesPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  ourAirportsPageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  ourProfilePageHeading: [
    {
      fieldName: "Banner Image",
      fieldValue: "field_page_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_page_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Enter Banner Image URL",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Page Title (EN)",
      fieldValue: "field_page_title_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_en",
      formType: "input",
      label: "Page Title (EN)",
      placeholder: "Enter Page Title (EN)",
      validation: { required: "Page Title (EN) is required" },
    },
    {
      fieldName: "Page Title (MS)",
      fieldValue: "field_page_title_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_ms",
      formType: "input",
      label: "Page Title (MS)",
      placeholder: "Enter Page Title (MS)",
      // validation: { required: "Page Title (MS) is required" },
    },
    {
      fieldName: "Page Title (ZH)",
      fieldValue: "field_page_title_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_title_zh",
      formType: "input",
      label: "Page Title (ZH)",
      placeholder: "Enter Page Title (ZH)",
      // validation: { required: "Page Title (ZH) is required" },
    },
    {
      fieldName: "Page Description (EN)",
      fieldValue: "field_page_description_en",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_en",
      formType: "richText",
      label: "Page Description (EN)",
      placeholder: "Enter Page Description (EN)",
      // validation: { required: "Page Description (EN) is required" },
    },
    {
      fieldName: "Page Description (MS)",
      fieldValue: "field_page_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_ms",
      formType: "richText",
      label: "Page Description (MS)",
      placeholder: "Enter Page Description (MS)",
      // validation: { required: "Page Description (MS) is required" },
    },
    {
      fieldName: "Page Description (ZH)",
      fieldValue: "field_page_description_zh",
      className: "col-span-6",
      type: "text",
      name: "field_page_description_zh",
      formType: "richText",
      label: "Page Description (ZH)",
      placeholder: "Enter Page Description (ZH)",
      // validation: { required: "Page Description (ZH) is required" },
    },
    // {
    //   fieldName: "Metadata Image",
    //   fieldValue: "field_page_metadata_image",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "field_page_metadata_image",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Metadata Image",
    //   placeholder: "Enter Metadata Image URL",
    //   validation: { required: "Metadata Image is required" },
    // },
    // {
    //   fieldName: "Metadata Title (EN)",
    //   fieldValue: "field_page_metadata_title_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_en",
    //   formType: "input",
    //   label: "Metadata Title (EN)",
    //   placeholder: "Enter Metadata Title (EN)",
    //   validation: { required: "Metadata Title (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (MS)",
    //   fieldValue: "field_page_metadata_title_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_ms",
    //   formType: "input",
    //   label: "Metadata Title (MS)",
    //   placeholder: "Enter Metadata Title (MS)",
    //   // validation: { required: "Metadata Title (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Title (ZH)",
    //   fieldValue: "field_page_metadata_title_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_title_zh",
    //   formType: "input",
    //   label: "Metadata Title (ZH)",
    //   placeholder: "Enter Metadata Title (ZH)",
    //   // validation: { required: "Metadata Title (ZH) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (EN)",
    //   fieldValue: "field_page_metadata_desc_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_en",
    //   formType: "richText",
    //   label: "Metadata Description (EN)",
    //   placeholder: "Enter Metadata Description (EN)",
    //   validation: { required: "Metadata Description (EN) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (MS)",
    //   fieldValue: "field_page_metadata_desc_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_ms",
    //   formType: "richText",
    //   label: "Metadata Description (MS)",
    //   placeholder: "Enter Metadata Description (MS)",
    //   // validation: { required: "Metadata Description (MS) is required" },
    // },
    // {
    //   fieldName: "Metadata Description (ZH)",
    //   fieldValue: "field_page_metadata_desc_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_page_metadata_desc_zh",
    //   formType: "richText",
    //   label: "Metadata Description (ZH)",
    //   placeholder: "Enter Metadata Description (ZH)",
    //   // validation: { required: "Metadata Description (ZH) is required" },
    // },
  ],
  ourBrandNextPage: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_nextPage_name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter Next Page Name (EN)",
      validation: { required: "Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay_nextPage_name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter Next Page Name (MS)",
      // validation: { required: "Next Page Name (MS) is required" },
    },
    // {
    //   fieldName: "Next Page Link (MS)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay_nextPage_link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter Next Page Link (MS)",
    //   // validation: { required: "Next Page Link (MS) is required" },
    // },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin_nextPage_name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter Next Page Name (ZH)",
      // validation: { required: "Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english_nextPage_link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter Next Page Link",
      validation: { required: "Next Page Link is required",validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
} },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin_nextPage_link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter Next Page Link (ZH)",
    //   // validation: { required: "Next Page Link (ZH) is required" },
    // },
  ],
};
